import React, { Component } from 'react';
import logo from './../images/caja-registradora.png'
class getMsgboxCaja extends Component {
  render(){

      return (
        <React.Fragment>
        Caja Cerrada<br/>
        <img src={logo} alt="Logo" />
        </React.Fragment>
      )
  }
  componentDidMount() {
     this.props.validar_caja_activa();
  }
}

export default getMsgboxCaja;
